import axios, { Axios } from 'axios';
import {
  IActivateResDto, ILoginBody, IOtpAuthDto, ISignInResDto,
} from 'store/user/types/api-bodies.types';
import { getIdleLogoutMinutes, rememberIdleTimeout } from 'utils/session-activity';

const authClient: Axios = axios.create({
  baseURL: '/panel-main/api',
});

authClient.interceptors.response.use((res) => {
  if (res.data?.data?.accessToken) {
    rememberIdleTimeout(res.data.data.sessionIdleTimeoutMinutes);
  }
  return res;
});

export const authService = {
  signIn: (dto: ILoginBody, lang: string) => authClient.post<ISignInResDto>('v1/auth/sign-in', dto, {
    headers: {
      'X-Lang': lang,
    },
  }),

  // После простоя сессию продолжает только вход с паролем. Проверка здесь, потому что токен
  // обновляют и перехватчики запросов, например на 401 от загрузчика страницы
  refreshToken: async () => {
    if (getIdleLogoutMinutes() > 0) throw new Error('Session idle timeout');
    return authClient.post<ISignInResDto>('v1/auth/refresh-token');
  },

  signInOtpConfirm: ({ totpKey, ...dto }: IOtpAuthDto, lang: string) => authClient.post<ISignInResDto>('2fa/validateQrCode', { ...dto, totpKey: Number(totpKey) }, {
    headers: {
      'X-Lang': lang,
    },
  }),

  resetPasswordSendEmail: (email: string, lang: string) => authClient.post('v1/auth/reset-password-request', { email }, {
    headers: {
      'X-Lang': lang,
    },
  }),
  resetPasswordConfirm: (password: string, token: string) => authClient.post('v1/auth/reset-password', { password, token }),
  activateSelfRegistrationUser: (password: string, token: string) => authClient.post<IActivateResDto>('v2/self-registration/activate', { password, token }),
  changeLoginConfirm: (token: string) => authClient.get('v1/auth/confirm-email', { params: { token } }),
  deactivateAccountConfirm: (token: string) => authClient.post('user/deactivate', undefined, { params: { token } }),
};

export default authClient;
